module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.01798bc1.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.ttf?d7yf1v
 ** module id = 1608
 ** module chunks = 0
 **/